var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{ref:"footer"},[_c('p',{staticClass:"copyright"},[_vm._v("\n        ©Copyright, 2019 WiASSUR, tous droits reservés\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }